import React from 'react';
import { MousePosition } from '../types';

interface AnimatedBackgroundProps {
    mousePosition: MousePosition;
}

const translate = (x: number, y: number): string => `translate(${x}px, ${y}px)`;

const AnimatedBackground: React.FC<AnimatedBackgroundProps> = ({
    mousePosition,
}) => (
    <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-950 to-yellow-600" />
        <div
            className="hidden sm:block absolute top-1/4 left-1/4 w-40 h-40 sm:w-72 sm:h-72 bg-yellow-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"
            style={{
                transform: translate(
                    mousePosition.x * 0.02,
                    mousePosition.y * 0.02
                ),
                animationDuration: '4s',
            }}
        />
        <div
            className="hidden sm:block absolute top-1/3 right-1/3 w-56 h-56 sm:w-96 sm:h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"
            style={{
                transform: translate(
                    mousePosition.x * -0.03,
                    mousePosition.y * -0.03
                ),
                animationDelay: '2s',
                animationDuration: '6s',
            }}
        />
        <div
            className="hidden sm:block absolute bottom-1/4 left-1/3 w-48 h-48 sm:w-80 sm:h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"
            style={{
                transform: translate(
                    mousePosition.x * 0.01,
                    mousePosition.y * 0.01
                ),
                animationDelay: '4s',
                animationDuration: '8s',
            }}
        />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:30px_30px] sm:bg-[size:50px_50px]" />
    </div>
);

export default AnimatedBackground; 